import * as React from "react";
import TextField from "@mui/material/TextField";
import { enGB } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";

export default function MaterialUIPickers({
  label,
  name,
  value,
  dateTimePicker,
  onChange,
  sx,
  className,
  disabled,
  disableFuture,
  minDate = "",
  maxDate = "",
  fullwidth,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
      {dateTimePicker === true ? (
        <DesktopDateTimePicker
          name={name}
          label={label}
          //inputFormat="dd/MM/yyyy hh:mm aa"
          format="dd/MM/yyyy hh:mm aa"
          value={value}
          // minDate={minDate}
          // maxDate={maxDate}
          sx={{ width: "100%" }}
          onChange={onChange}
          ignoreInvalidInputs={true}
          disableFuture={disableFuture}
          inputRef={{ maxDate: { maxDate }, minDate: { minDate } }}
          slotProps={{
            textField: { size: "small" },
            field: {
              readOnly: true,
            },
          }}
          renderInput={(params) => (
            <TextField {...params} sx={sx} className={className} />
          )}
          disabled={disabled}
          fullwidth={fullwidth}
        />
      ) : (
        <DesktopDatePicker
          label={label}
          // inputFormat="dd/MM/yyyy"
          format="dd/MM/yyyy"
          value={value}
          minDate={minDate}
          maxDate={maxDate}
          onChange={onChange}
          ignoreInvalidInputs={true}
          disableFuture={disableFuture}
          slotProps={{
            textField: { size: "small" },
            field: {
              readOnly: true,
            },
          }}
          renderInput={(params) => (
            <TextField {...params} sx={sx} className={className} />
          )}
          disabled={disabled}
        />
      )}
    </LocalizationProvider>
  );
}
